<template>
  <v-container v-if="brand"
               fluid>
    <PageTitle icon="fas fa-fw fa-store">
      Edit Brand
    </PageTitle>

    <v-form @submit.prevent="submit"
            :disabled="form.busy"
            autocomplete="off">
      <BrandForm :form="form"
                 :brand="brand">
      </BrandForm>
    </v-form>
  </v-container>
</template>
<script>
import {Form} from 'vform';
import brandService from '../../services/brandService';
import BrandForm from './components/BrandForm.vue';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle, BrandForm},
  data() {
    return {
      busy: false,
      form: new Form({
        name: null,
        status: 'Active',
        external_id: null,
        presentations: [],
        templates: [],
      }),
      brand: null,
    }
  },
  computed: {
    brandID() {
      if (this.$route.params.brandID) {
        return parseInt(this.$route.params.brandID);
      }
      return null;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.busy = true;
      brandService.getBrand(this.brandID)
        .then(data => {
          this.brand = data;
          this.form.name = data.name;
          this.form.external_id = data.external_id;
          this.form.status = data.status;
          this.form.presentations = data.presentations;
          this.form.templates = data.templates;
        })
        .catch(() => {
          this.$toast.error('Brand not found.');
          this.$router.replace({name: 'admin.brands.index'});
        })
        .finally(() => {
          this.busy = false;
        })
    },
    submit() {
      if (this.form.busy) {
        return;
      }
      this.form.startProcessing();
      const form = this.form.data();
      form.presentations = form.presentations.map(p => p.id);
      form.templates = form.templates.map(t => t.id);
      this.form.put(`/api/brands/${this.brand.id}`, {data: form})
        .then(() => {
          this.$toast.success('Brand updated.');
          setTimeout(() => {
            this.$router.push({name: 'admin.brands.index'});
          }, 500);
        })
        .catch(err => {

        })
    },
  }
}
</script>
